import $ from 'jquery'
import {frame, unframe, redraw, isTouch} from '../utilities'

import Base from 'luminate/src/modules/base'

const $window = $(window)
let viewportHeight = $window.height()

$window.on('resize', e => viewportHeight = $window.height())

export default Base.extend({
	directive: 'scroll-fader',

	defaults: {
		offset: 1,
		distance: 0.1
	},

	events: {

		init: function()
		{
			// Disable for touch-screen devices
			if(isTouch()) return

			const $element = $(this.$element)
			const offset = Math.max(0, Math.min(parseFloat(this.$settings.offset), 1))
			const distance = Math.max(0, Math.min(parseFloat(this.$settings.distance), 1))

			let height
			let position

			function setup()
			{
				height = $element.outerHeight()
				position = $element.offset()

				update()
			}

			function update()
			{
				const scrollTop = $window.scrollTop()
				const scrollDistance = viewportHeight * distance

				let opacity = 1

				// TODO

				$element.css('opacity', opacity)
			}

			setup()

			let resizeId
			$window.on('load resize', e =>
			{
				unframe(resizeId)
				resizeId = frame(setup)
			})

			let scrollId
			$window.on('scroll', e =>
			{
				unframe(scrollId)
				resizeId = frame(update)
			})
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/legacy/modules/scroll-fader.js